export default {}

export const ITEM_PER_PAGE_FOR_PLACEHOLDER = 2
